// extracted by mini-css-extract-plugin
export default {"feedBookmarkSaved":"BookmarkIcon_feedBookmarkSaved__5QpW-","pendingBookmark":"BookmarkIcon_pendingBookmark__FUpv2"};